/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { ledgersRetrieveApiV2LedgersLedgerCanisterIdGet } from "../../funcs/ledgersRetrieveApiV2LedgersLedgerCanisterIdGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations.RetrieveApiV2LedgersLedgerCanisterIdGetRequest$inboundSchema,
};

export const tool$ledgersRetrieveApiV2LedgersLedgerCanisterIdGet:
  ToolDefinition<typeof args> = {
    name: "ledgers-retrieve-api-v2-ledgers-ledger-canister-id-get",
    description: `Get ledger`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await ledgersRetrieveApiV2LedgersLedgerCanisterIdGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
